import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	skeletonLongLine: {
		height: '12px',
		width: '80%',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.large'),
	},
	skeletonShortLine: {
		height: '12px',
		width: '40%',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.large'),
	},
	skeletonLine: {
		height: '12px',
		width: '60%',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.large'),
	},
});

export const SnippetPreviewSkeleton = () => (
	<Stack space="space.050">
		<Box xcss={styles.skeletonLongLine} />
		<Box xcss={styles.skeletonLine} />
		<Box xcss={styles.skeletonLongLine} />
		<Box xcss={styles.skeletonShortLine} />
	</Stack>
);
